import { default as utils } from "./modules/_utils.js";
import { default as scroll } from "./modules/_scroll.js";

(function () {
	utils.init();
	scroll.init();
})();
